export const productShortName = 'Energie Rinnovabili — Edizione Docenti';
export const productBrand = 'Energie Rinnovabili';
export const productEdition = 'Edizione Docenti';
export const productImage = 'https://cdn.magicpatterns.com/uploads/g6N4EPzhbdHMUY4Mr6uV1i/MOCKUP_ENERGIE_RINNOVABILI.png';
export const productImageAlt =
  'Energie Rinnovabili Edizione Docenti: collezione didattica in 6 volumi con 5 risorse bonus, circondata da pannello solare, turbina eolica e batteria';

export const checkoutUrl = 'https://energie-rinnovabili-docenti.impultienda.ar/checkout';

export const price = '€27';
export const priceBefore = '€80';

export const totalVolumes = 6;
export const totalBonuses = 5;
export const bonusValue = '€17';
export const bonusTotalValue = '€85';

export const assurances = ['Pagamento sicuro', 'Accesso immediato', 'Garanzia di 7 giorni'];

export const closingLines = [
  'Basta preparare ogni lezione da zero',
  'Basta spiegare fotovoltaico ed eolico senza materiali chiari',
  'Basta cercare attività ed esperimenti sparsi su internet',
  "Basta verifiche improvvisate all'ultimo minuto",
  'Basta studenti distratti durante le lezioni di scienze',
];
